import { useTranslation } from 'react-i18next';

import { gql, useMutation } from '@apollo/client';
import { showNotification, NOTIFICATION_TYPE } from '@thinknet-gmbh/platform-common-ui';

import { GET_CURRENT_SUBSCRIPTION } from 'src/hooks/subscriptions/get-current-subscription.hook';

import { GET_EMPLOYEES } from './get-employees.hook';

const DELETE_EMPLOYEE = gql`
  mutation deleteEmployee($payload: GetEmployeeByIdInput!) {
    deleteEmployee(payload: $payload)
  }
`;

export const useDeleteEmployee = ({ onSuccess }: { onSuccess: () => void }) => {
  const { t } = useTranslation(['common', 'employee']);

  const [deleteEmployee] = useMutation(DELETE_EMPLOYEE, {
    refetchQueries: [GET_EMPLOYEES, GET_CURRENT_SUBSCRIPTION],
    onCompleted: onSuccess,
    onError: () =>
      showNotification({
        type: NOTIFICATION_TYPE.error,
        message: t('common:notifications.error.title'),
        description: t('common:notifications.error.subTitle'),
      }),
  });

  return deleteEmployee;
};
